// FORGED Ed Systems — DEPLOY003 — v0.3.0 — IntakeStep1OperatingMode.tsx
// Last touched: 2026-05-19
//
// Step 1 of intake: Where are you in the term?

import type { OperatingMode } from "./types";

type Props = {
  value: OperatingMode | null;
  onChange: (v: OperatingMode) => void;
};

const MODES: { id: OperatingMode; label: string; description: string }[] = [
  {
    id: "start_of_year",
    label: "Start of year",
    description:
      "I'm planning the full academic year. We'll project a full-year strategy.",
  },
  {
    id: "mid_year",
    label: "Mid-year",
    description:
      "We're partway through and I need a recovery plan from here. We'll generate a differentiated multi-track plan covering the time remaining.",
  },
  {
    id: "cert_prep_window",
    label: "Cert prep window",
    description:
      "I have a known cert test date and need to focus the final weeks. For 1-12 week windows.",
  },
];

export default function IntakeStep1OperatingMode({ value, onChange }: Props) {
  return (
    <div>
      <h2>Where are you in the term?</h2>
      <p className="step-description">
        Your operating mode changes what we ask next and what your plan looks
        like. Mid-year and cert-prep plans focus on the time you have left and
        split your cohort into tracks.
      </p>

      <div className="mode-card-row">
        {MODES.map((mode) => {
          const selected = value === mode.id;
          return (
            <button
              key={mode.id}
              type="button"
              onClick={() => onChange(mode.id)}
              className={"mode-card" + (selected ? " mode-card-selected" : "")}
            >
              <div className="mode-card-radio">{selected ? "●" : "○"}</div>
              <div className="mode-card-label">{mode.label}</div>
              <div className="mode-card-description">{mode.description}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
